var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteRightArrowExtended(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 8,
    viewBox: "0 0 27 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0537 4.35355C26.249 4.15829 26.249 3.84171 26.0537 3.64645L22.8718 0.464466C22.6765 0.269204 22.3599 0.269204 22.1647 0.464466C21.9694 0.659728 21.9694 0.976311 22.1647 1.17157L24.9931 4L22.1647 6.82843C21.9694 7.02369 21.9694 7.34027 22.1647 7.53553C22.3599 7.7308 22.6765 7.7308 22.8718 7.53553L26.0537 4.35355ZM0.200195 4.5H25.7002V3.5H0.200195V4.5Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRightArrowExtended);
export default __webpack_public_path__ + "static/media/white-right-arrow-extended.8021e40fb9319b6aa87f242fe4b2174d.svg";
export { ForwardRef as ReactComponent };